if(!customElements.get('component-timeline-carousel')) {
  class ComponentTimelineCarousel extends HTMLElement {
    constructor() {
      super();
      this.wheel = this.querySelector(".wheel");
      this.carouselElement = this.querySelector("component-carousel");
      this.keenSliderElement = this.carouselElement?.querySelector('.keen-slider');
      
      if (this.wheel && this.keenSliderElement && this.carouselElement) {
        setTimeout(()=>{
          this.initGSAP();
        }, 1);
      }
    }

    initGSAP() {
      gsap.registerPlugin(Draggable, Flip);

      let images = gsap.utils.toArray(this.wheel.querySelectorAll(".wheel-card"));
      
      if (images.length === 0) {
        return;
      }

      const setup = () => {
        let radius = this.wheel.offsetWidth / 2,
          center = radius,
          slice = 360 / images.length,
          DEG2RAD = Math.PI / 180;
        gsap.set(images, {
          x: i => center + radius * Math.sin(i * slice * DEG2RAD),
          y: i => center - radius * Math.cos(i * slice * DEG2RAD),
          rotation: i => i * slice,
          xPercent: -50,
          yPercent: -50
        });
      };

      setup();
      window.addEventListener("resize", setup);

      const updateWheelRotation = () => {
        if (!this.carouselElement.sliderObj) return;
        
        const details = this.carouselElement.sliderObj.details();
        const currentSlideIndex = details.relativeSlide;
        const totalSlides = this.keenSliderElement.children.length;
        const rotationPerSlide = 360 / totalSlides;
        const targetRotation = -currentSlideIndex * rotationPerSlide;
        
        gsap.to(this.wheel, {
          rotation: targetRotation,
          duration: 0.5,
          ease: "power2.out"
        });
      };
      
      const initCheck = setInterval(() => {
        if (this.carouselElement.sliderObj) {
          clearInterval(initCheck);
          
          updateWheelRotation();
          
          this.keenSliderElement.addEventListener('keen.slideChanged', updateWheelRotation);
        }
      }, 50);
    }
  }
  customElements.define('component-timeline-carousel', ComponentTimelineCarousel);
}
